export const envBuildIsApp = import.meta.env.VITE_MIRRO_BUILD_TARGET === 'app'
